/**
 * FOCUS MODE kill-list (frontend) — single source of truth.
 *
 * Off-thesis pages are "parked": hidden by default so the product (and the
 * investor/user demo) stays focused on the verifiable-evidence core, the
 * developer/white-label API, and the federal/cross-border vertical.
 *
 * NOTHING IS DELETED. This is fully reversible:
 *   - Frontend: set REACT_APP_ENABLE_PARKED=true  (then restart frontend)
 *   - Backend:  set ENABLE_PARKED_FEATURES=true    (then restart backend)
 *
 * When focus mode is on, every PARKED_PATH renders the NotFound page and the
 * matching backend routers are left unregistered.
 */

export const FOCUS_MODE =
  String(process.env.REACT_APP_ENABLE_PARKED).toLowerCase() !== 'true';

// Grouped by cluster to mirror backend routes_registry.PARKED_MODULES.
export const PARKED_PATHS = [
  // Experimental / agent / AI feature-pile
  '/ai-generator', '/ai-summarizer', '/ai-intelligence', '/doc-compare',
  '/conductor/:transactionId', '/admin/blueprints/create',
  '/anan', '/anan/:ceremonyId',
  // Two-sided marketplaces
  '/marketplace', '/template-marketplace',
  // Notary education / training
  '/academy', '/academy/module/:moduleId', '/academy/exam', '/admin/academy',
  '/training/florida-manual', '/practice',
  // Speculative digital-identity surface
  '/sovereign-id', '/sovereign/verify/:sovereignId',
  '/identity', '/identity/challenge/:token',
  '/biometric-passport', '/id/:cardId', '/notary/id-card', '/verify/wallet',
  // Tokenization / crypto
  '/checkout/crypto', '/smart-contracts', '/tokenized-escrow',
  // CRM / growth tooling — RE-ACTIVATED (kept live for data collection, CRM & marketing)
  // '/partners', '/partners/kit', '/admin/partners',
  // '/admin/campaign-links', '/admin/sales-leads',
  // Fraud / threat product surface
  '/fraud-shield', '/fraud-intelligence', '/notaryguard', '/notaryguard/verify',
  // Contract-lifecycle (CLM)
  '/loi', '/loi/sign/:token',
  '/deals', '/deals/:id', '/deals/sign/:token', '/deals/view/:token',
  '/drafts/shared/:shareToken',
  // Separate lines / one-off utilities
  '/scanner', '/scanner/demo', '/tools/pdf-splitter',
  '/escrow', '/escrow/:escrowId', '/escrow/view/:token',
  '/verify/escrow', '/verify/escrow/:contractId',
  '/verify/contract', '/verify/contract/:hash',
  '/eclosing', '/title-company', '/apostille', '/e-apostille',
  '/notary/earnings',
  // Reachable-but-broken surfaces whose backends are parked (hidden until re-activated)
  '/contractor/app', '/admin/coercion-drill', '/reviews/insights',
  '/ceremony-replay/:ceremonyId',
];

// Exact-match helper for hiding dead nav links/tiles pointing at parked,
// static paths while FOCUS MODE is on. (Dynamic ":param" paths are matched by
// the router; nav links only ever target static paths.)
export const isParked = (path) => FOCUS_MODE && PARKED_PATHS.includes(path);
